export default {
    "contact.title": "Contact Us",
    "contact.seo_description": "Any questions? Our team is at your disposal to help with your citizenship exam preparation.",
    "contact.hero.title": "Contact Us",
    "contact.hero.subtitle": "Got a question about our app? Need help with your preparation? Our team is here to support you.",
    "contact.nav.back": "Back",

    "contact.info.email.title": "Email",
    "contact.info.email.response": "Typical response time: 24-48 hours",
    "contact.info.address.title": "Address",
    "contact.info.address.value": "Saguenay, Quebec, Canada",
    "contact.info.phone.title": "Phone",
    "contact.info.phone.hours": "(Mon-Fri, 9am-5pm EST)",
    "contact.info.others.title": "Other ways to reach us",

    "contact.form.name.label": "Full Name",
    "contact.form.name.placeholder": "Your name",
    "contact.form.email.label": "Email",
    "contact.form.email.placeholder": "your@email.com",
    "contact.form.message.label": "Message",
    "contact.form.message.placeholder": "How can we help you?",
    "contact.form.submit": "Send Message",
    "contact.form.sending": "Sending...",
    "contact.form.error": "An error occurred while sending the message.",

    "contact.success.title": "Message Sent!",
    "contact.success.desc": "Thank you for reaching out. Our team will get back to you as soon as possible.",
    "contact.success.cta": "Send another message",

    "contact.footer.copyright": "© 2025 CitoyenPro. All rights reserved."
};
